import { getDatesInRange } from 'src/utils/dateFns/getDateRange';

export const requestDatesRange = (requests) => {
  const requestsRange = [];
  requests.forEach((request) => {
    const dates = new Set(
      getDatesInRange(new Date(request.startDate), new Date(request.endDate))
    );
    requestsRange.push({ ...request, dates });
  });
  return requestsRange;
};
